import { useState, useMemo } from "react"
import { FiX } from "react-icons/fi"
import Input from "../../../shared/components/form/input"
import Checkbox from "../../../shared/components/form/checkbox"
import Button from "../../../shared/components/Button/Button"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Modal from "../../../shared/modal/Modal"
import ChecklistItem from "../../ChecklistItem/ChecklistItem"
import useGroupOrders from '../../../hooks/useGroupOrders'
import { buildChecklistSections } from '../../../utils/checklistSections'
import './FormProcedure.css'

function FormProcedure({ handleSubmit, procedureData, btnText, btCancelAction, title }) {

    const [procedure, setProcedure] = useState(procedureData || {})
    const [items, setItems] = useState(procedureData?.items || [])
    const [modalSelectItems, setModalSelectItems] = useState(false)

    function handleChange(e) {
        setProcedure(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    function handleChangeCheckbox(name, value) {
        setProcedure(prev => ({ ...prev, [name]: value }))
    }

    const removeItem = (item) => setItems(items.filter(i => i._id !== item._id))

    function submit(e) {
        e.preventDefault()
        handleSubmit({ ...procedure, items })
    }

    const groupOrders = useGroupOrders()

    const sections = useMemo(
        () => buildChecklistSections(items, groupOrders),
        [items, groupOrders]
    )

    return (
        <>
            <FormLayout requiredLegend
                title={title}
                onSubmit={submit}
                actions={
                    <>
                        <Button variant="save" type="submit">
                            {btnText || 'Salvar'}
                        </Button>
                        {btCancelAction && (
                            <Button variant="cancel" onClick={btCancelAction}>
                                Cancelar
                            </Button>
                        )}
                    </>
                }
            >
                <FormSection label="Procedimento">
                    <div className="fl-row">
                        <div className="fl-col-wide form-group">
                            <Input
                                required
                                text="Nome do procedimento"
                                type="text"
                                name="name"
                                placeholder="Ex: Manutenção Preventiva"
                                handleOnChange={handleChange}
                                value={procedure.name || ''}
                            />
                        </div>
                    </div>
                    <div className="fl-row">
                        <div className="fl-col-wide form-group">
                            <Input
                                text="Descrição"
                                type="text"
                                name="description"
                                placeholder="Descreva o procedimento"
                                handleOnChange={handleChange}
                                value={procedure.description || ''}
                            />
                        </div>
                    </div>
                    <div className="form-group">
                        <Checkbox
                            text="Procedimento desabilitado"
                            name="disabled"
                            handleOnChange={() => handleChangeCheckbox("disabled", !procedure.disabled)}
                            check={procedure.disabled || false}
                        />
                    </div>
                </FormSection>

                <FormSection label="Itens do Checklist">
                    <Button variant="select" onClick={() => setModalSelectItems(true)}>Selecionar</Button>

                    <div className="pr-list">
                        {sections.length > 0 ? (
                            sections.map((section) => (
                                <div key={section.groupLabel} className="pr-group-section">
                                    <div className="pr-group-header">{section.groupLabel}</div>
                                    {section.items.map((item) => (
                                        <div key={item._id} className="pr-item">
                                            <span className="pr-item-name">{item.name}</span>
                                            <button type="button" className="pr-item-remove" title="Remover" onClick={() => removeItem(item)}>
                                                <FiX size={16} />
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            ))
                        ) : (
                            <p className="pr-empty">Nenhum item selecionado</p>
                        )}
                    </div>
                </FormSection>
            </FormLayout>

            <Modal
                modalStatus={modalSelectItems}
                changeStatus={setModalSelectItems}
                w={70}
                content={
                    <ChecklistItem
                        selectItem={true}
                        handleOnSelectItem={setItems}
                        selectedData={items}
                        onFinishSelect={() => setModalSelectItems(false)}
                    />
                }
            />
        </>
    )
}

export default FormProcedure
